// Чистые правила «чья это подписка и можно ли ей верить». Без React и сети —
// покрыты subscription.test.ts.
/**
 * id авторизованного АККАУНТА либо `null`. Гость — не аккаунт: подписки у него
 * быть не может, и запрос за ней бэк отклонит (403).
 */
export function resolveAccountId({ isAuthenticated, user }) {
    if (!isAuthenticated || !user || user.is_guest)
        return null;
    return user.id;
}
/**
 * Подписка из стора — только если она принадлежит ТЕКУЩЕМУ аккаунту. Стор
 * глобальный и переживает смену пользователя (вышел → вошёл под другим): без
 * сверки новый пользователь на кадр увидел бы чужую подписку и лишился бы
 * подписочных тарифов в витрине.
 */
export function selectOwnSubscription(accountId, ownerId, subscription) {
    if (accountId === null || ownerId !== accountId)
        return null;
    return subscription;
}
/**
 * Известно ли уже, есть ли у пользователя подписка. Гостю/неавторизованному —
 * сразу да (её нет). Аккаунту — когда пришёл ответ именно по нему.
 */
export function isSubscriptionResolved(accountId, ownerId, resolved) {
    if (accountId === null)
        return true;
    return ownerId === accountId && resolved;
}
